// extracted by mini-css-extract-plugin
module.exports = {"load":"Loading_load__1o7gs","ring":"Loading_ring__1nswv","loading":"Loading_loading__JeKF6"};